@if(sideKeyboard() && toggleMainKeyboardButton) {
    <app-cashregister-side-keyboard
        [form]="form"
        [buttons]="buttons"
        [integerMultiply]="integerMultiply"
        [toggleMainKeyboardButton]="toggleMainKeyboardButton"
        [principalActionButton]="principalActionButton"
        [actionButtons]="actionButtons"
        [fastPaymentsButtons]="fastPaymentsButtons"
        [sale]="sale"
        [cashValue]="cashValue"
        (onFieldChange)="onFieldChange($event)"
        [keyboardFontSize]="keyboardFontSize()"
    />
} @else {
    <app-cashregister-keypad class="tw-col-span-2 tw-h-full tw-text-2xl" [field]="cashValue" (fieldChange)="onFieldChange($event)" [integerMultiply]="integerMultiply" [keyboardFontSize]="keyboardFontSize()" />
    <app-tilby-sale-keypad class="tw-col-span-3" [form]="form" [buttons]="buttons" (activateSideKeyboard)="activateSideKeyboard.emit($event)" [keyboardFontSize]="keyboardFontSize()" />
}
